import { render, staticRenderFns } from "./mainPane.vue?vue&type=template&id=6044ff40&scoped=true"
import script from "./mainPane.vue?vue&type=script&lang=js"
export * from "./mainPane.vue?vue&type=script&lang=js"
import style0 from "./mainPane.vue?vue&type=style&index=0&id=6044ff40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6044ff40",
  null
  
)

export default component.exports